import { isMobile } from './is-mobile';

export function responsiveUrl(desktopUrl: string, mobileUrl: string) {
    if (isMobile()) {
        return mobileUrl;
    }
    return desktopUrl;

}